export enum Collections {
  USERS = 'users',
  ORGANIZATIONS = 'organizations',
  ORGANIZATION_INVITES = 'organization_invites',
  TEAMS = 'teams',
  COURSE = 'courses',
  QUESTIONARES = 'questionnaires',
  LOGIN_WITH_CODE_TOKEN = 'login_with_code_token',
  SPRINTS = 'sprints',
  SPRINT_REPORTS = 'sprint_reports',
  REPORTS = 'reports',
  TRANSLATIONS = 'translations',
  LEARNING_MATERIALS = 'learning_materials',
  VOICE_CLASS_PROTOTYPES = 'voice_class_prototypes',
  WHEREBY_TASKS = 'whereby_tasks',
  WHEREBY_MEETINGS = 'whereby_meetings',
  WHEREBY_ROOM_CLAIMS = 'whereby_room_claims',
  WHEREBY_ROOM_PRESENCE = 'whereby_room_presence',
  WHEREBY_CALL_OWNERSHIP = 'whereby_call_ownership',
  ACHIEVEMENTS = 'achievements',
  AI_COACH_SESSIONS = 'ai_coach_sessions',
  AI_COACH_INTRO_ASSETS = 'ai_coach_intro_assets',
  REPORT_GENERATION_TASKS = 'report_generation_tasks',
  PROFILE_REPORT_TASKS = 'profile_report_tasks',
  LEADER_SCOPES = 'leader_scopes',
  LEADER_INSIGHTS = 'leader_insights',
  LEADER_INSIGHTS_TASKS = 'leader_insights_tasks',
  EXPERT_VIDEOS = 'expertVideos',
  TUTORIAL_VIDEOS = 'tutorialVideos',
  BLOG_POSTS = 'blogPosts',
  QUOTES = 'quotes',
  LANDING_CONFIG = 'landingConfig',
  AI_MODEL_CONFIG = 'aiModelConfig',
  SESSION_AI_RECOVERY_TASKS = 'session_ai_recovery_tasks',
  USER_DEMOGRAPHICS = 'userDemographics',
  SPRINT_PURPOSE_CONFIGS = 'sprint_purpose_configs',
  SPRINT_ACTIVITY_TYPE_CONFIGS = 'sprint_activity_type_configs',
  IN_APP_NOTIFICATIONS = 'inAppNotifications',
  REFLECTIONS = 'reflections',
  ASSISTANT_LIVE_TOKEN_USAGE = 'assistant_live_token_usage',
  ASSISTANT_CHAT_USAGE = 'assistant_chat_usage',
  ARIA_ORGANIZATION_USAGE = 'aria_organization_usage',
  ASSISTANT_ESCALATION_USAGE = 'assistant_escalation_usage',
  ASSISTANT_SUPPORT_MESSAGE_USAGE = 'assistant_support_message_usage',
  ASSISTANT_ESCALATIONS = 'assistant_escalations',
  /** Subcollection of the above: who answered. Never readable by the participant — rules deny it. */
  ASSISTANT_ESCALATION_AGENTS = 'assistant_escalation_agents',
  COACH_CONVERSATIONS = 'coach_conversations',
  /** The old home of the coach default; only the seeders read it. */
  COACH_CONFIG = 'coach_config',
  /** Aria's prompts before Data Customization; only the seeders read it. */
  ARIA_PROMPTS = 'aria_prompts',
  PLATFORM_SETTINGS = 'platform_settings',
  COACH_MESSAGE_USAGE = 'coach_message_usage',
  COACH_VOICE_TURN_USAGE = 'coach_voice_turn_usage',
  COACH_GOAL_WRITE_USAGE = 'coach_goal_write_usage',
  COACH_REMEMBER_USAGE = 'coach_remember_usage',
  ASSISTANT_TALK_START_USAGE = 'assistant_talk_start_usage',
  SCHEDULED_EMAILS = 'scheduled_emails',
  FOLLOW_UP_CAMPAIGNS = 'follow_up_campaigns',
  /** Prompts, values and formulas per level and area (Data Customization). */
  DATA_CUSTOMIZATIONS = 'data_customizations',
  DATA_CUSTOMIZATION_DRAFTS = 'data_customization_drafts',
  DATA_CUSTOMIZATION_VARIANTS = 'data_customization_variants',
  DATA_CUSTOMIZATION_EXPERIMENTS = 'data_customization_experiments',
  DATA_CUSTOMIZATION_EXPERIMENT_TASKS = 'data_customization_experiment_tasks',
  DATA_CUSTOMIZATION_EXPERIMENT_USAGE = 'data_customization_experiment_usage',
  DATA_CUSTOMIZATION_JOBS = 'data_customization_jobs',
  DATA_CUSTOMIZATION_SEED_RUNS = 'data_customization_seed_runs'
}

export enum CollectionGroups {
  SLOTS = 'slots',
  SESSIONS = 'sessions',
  /** Written by the game under `courses/{courseId}` — one doc per group tutorial run, keyed by platform session id. */
  ONBOARDING_SESSIONS = 'onboardingSessions',
  DATA_POINTS = 'datapoints',
  EVENTS = 'events',
  QUESTIONS = 'questions',
  ACTIVITIES = 'activities',
  UTTERANCES = 'utterances',
  COACH_MESSAGES = 'messages',
  USER_GOALS = 'goals',
  USER_AI_AGENTS = 'ai_agents',
  /** Published versions under each `data_customizations` document. */
  DATA_CUSTOMIZATION_VERSIONS = 'data_customization_versions',
  /** Results under each `data_customization_experiments` document. */
  DATA_CUSTOMIZATION_RESULTS = 'data_customization_results'
}
